define('baseline/flare',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.findFlares = void 0;
    function findFlares(track) {
        var flares = [];
        // Find runs with increasing altitude
        for (var _i = 0, _a = track.segments(); _i < _a.length; _i++) {
            var segment = _a[_i];
            if (segment.mode === "Wingsuit") {
                var bottom = void 0, top_1 = void 0;
                for (var _b = 0, _c = segment.data; _b < _c.length; _b++) {
                    var point = _c[_b];
                    if (!bottom && point.climb >= 0) {
                        bottom = point;
                    }
                    else if (bottom && point.climb < 0) {
                        // Only log flares at least 1m
                        if (point.alt - bottom.alt >= 1) {
                            flares.push({ bottom: bottom, top: point });
                        }
                        bottom = undefined;
                        top_1 = undefined;
                    }
                    else if (bottom) {
                        // Still going up
                        top_1 = point;
                    }
                }
                // Check for flares at the end of the segment
                if (bottom && top_1) {
                    if (top_1.alt - bottom.alt >= 1) {
                        flares.push({ bottom: bottom, top: top_1 });
                    }
                }
            }
        }
        return flares;
    }
    exports.findFlares = findFlares;
});
//# sourceMappingURL=/assets/javascripts/baseline/flare.js.map;
